import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import * as AssetSubTypeType from '../../Store/AssetManagement/AssetSubType/AssetSubTypeType'
import { setAssetSubType } from 'Store/AssetManagement/AssetSubType/AssetSubTypeAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getVehicleType(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Values..."));
        const assetAndBranchId = req.assetTypeId;
        let payloadData : IPayload= {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/vehicletype/${assetAndBranchId}`,
        payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
        const defaultVehicleOption = {
            text: "Select Vehicle",
            value: null
        };
        response.unshift(defaultVehicleOption);
        }
        yield put(setAssetSubType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAssetSubType([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetAssetSubTypes() {
    yield takeEvery(AssetSubTypeType.GET_ASSET_SUB_TYPE, getVehicleType)
}

export default function* combinedSaga() {
    yield all([
        watchGetAssetSubTypes()
    ])
}
